/**
 *
 * 方案汇报 - 地形加载 1.0
 *
 * 功能点:打开,关闭地形
 * 场景:方案汇报
 *
 */
import Vue from "@/main";

export function terrainSwitch(type, id, fn, ...list) {
  let map = Vue.$GLOBAL.map;
  if (list.length > 0 && list[0] != undefined) {
    let { mapType } = list[0];

    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
    }
  }
  if (map.terrainProvider._layers && map.terrainProvider._layers != undefined) {
    if ((typeof type == "boolean" && type) || type == "true") {
      map.hasTerrain = true;
    } else {
      map.hasTerrain = false;
    }
  }

  // switch (type) {
  //   case "add":
  //     Vue.$GLOBAL.map.hasTerrain = true;
  //     break;
  //   case "remove":
  //     Vue.$GLOBAL.map.hasTerrain = false;
  //     break;
  //   default:
  //     break;
  // }
}
